import { connect } from "react-redux";
import AvatarPicker from "./AvatarPicker";
import {
  getDefaultAvatarId,
  getAvatars
} from "src/modules/avatar/duck/selectors";

function mapStateToProps(state) {
  const defaultAvatarId = getDefaultAvatarId(state);
  const avatars = getAvatars(state);

  return {
    selectedAvatar: avatars[defaultAvatarId],
    restOfAvatars: Object.values(avatars).filter(
      (avatar) =>
        avatar.objectId !== defaultAvatarId && avatar.deleted === false
    )
  };
}

export default connect(mapStateToProps)(AvatarPicker);
